import { render, staticRenderFns } from "./ResultDetailsDialog.vue?vue&type=template&id=278e2c90&"
import script from "./ResultDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./ResultDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ResultDetailsDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ResultDetailsDialog.vue"
export default component.exports